export enum MixpanelCardApplylEvent {
  IDpage_views = 'IDpage_views',
  IDpage_SSN = 'IDpage_SSN',
  IDpage_Income = 'IDpage_Income',
  Addresspop_Views = 'Addresspop_Views',
  ChangeAddressPop_Views = 'ChangeAddressPop_Views',
  ChangeAddressPop_UseAutocomplete = 'ChangeAddressPop_UseAutocomplete',
  PreApproved_Views = 'PreApproved_Views',
  PaymentPage_Views = 'PaymentPage_Views',
  PaymentPage_Duedate = 'PaymentPage_Duedate',
  SuccessPage_Views = 'SuccessPage_Views',
  IDpage_submitAtp = 'IDpage_submitAtp',
  PaymentPage_submit = 'PaymentPage_submit',
}
